
<template>
      <div class="car-num car-con">
            <div class="title">
                <img src="//www.ule.com/app/yxd/event/2019/0730/nianhj/images/jika/t3.png" alt="">
            </div>
            <div v-if="ifylxd" class="car-num-top"><i></i>每日分享
                <span class="sp2"><span class="sp3">{{shareorder.shareAmount>2?'2':shareorder.shareAmount}}</span>/2</span>
                <br><span class="sp1">每日分享可获得抽卡机会，一天限2次</span>
                <a data-stat="去分享" v-if="shareorder.shareAmount<2" href="ulemobile://uleHomepage">去分享</a>
                <a v-else　class="wanc" href="javascript:void(0);">明日再来</a>
            </div>
            <div v-if="ifylxd" class="car-num-top car-num-bot"><i></i>每日成单
                <span class="sp2"><span class="sp3">{{shareorder.orderAmount>3?'3':shareorder.orderAmount
                     }}</span>/3</span>
                <br><span class="sp1">每成1单可获得抽卡机会，一天限3次</span>
                <a data-stat="去下单" v-if="shareorder.orderAmount<3" href="ulemobile://uleHomepage">去完成</a>
                <a v-else　class="wanc" href="javascript:void(0);">明日再来</a>
            </div>
            <div v-if="!ifylxd" class="car-num-top"><i></i>每日分享
                <span class="sp2"><span class="sp3">{{ulefenx>1?'1':ulefenx}}</span>/1</span>
                <br><span class="sp1">每日分享年货节活动可获领卡资格，一天限1次</span>
                <a data-stat="去分享" v-if="ulefenx<1" href="//www.ule.com/app/yxd/event/2019/0730/nianhj/ulewap.html">去分享</a>
                <a v-else　class="wanc" href="javascript:void(0);">明日再来</a>
            </div>
            <div v-if="!ifylxd" class="car-num-top car-num-kan"><i></i>每日浏览
                <span class="sp2"><span class="sp3">{{ulellan>2?'1':ulellan}}</span>/1</span>
                <br><span class="sp1">每日浏览邮特惠，一天限1次</span>
                <a data-stat="去分享" v-if="ulellan<1" href="//www.ule.com/event/tmpl/ulewap.html?actId=619">去浏览</a>
                <a v-else　class="wanc" href="javascript:void(0);">明日再来</a>
            </div>
            <div v-if="!ifylxd" class="car-num-top car-num-bot"><i></i>每日成单
                <span class="sp2"><span class="sp3">{{ulechengd>3?'3':ulechengd}}</span>/3</span>
                <br><span class="sp1">每日成单可获得领卡资格，一天限3次</span>
                <a data-stat="邮乐网去成单" v-if="ulechengd<3" href="//www.ule.com/app/yxd/event/2019/0730/nianhj/ulewap.html">去下单</a>
                <a v-else　class="wanc" href="javascript:void(0);">明日再来</a>
            </div>
            <div class="car-num-top car-num-bot youxi"><i></i>每日游戏
                <br><span class="sp1">每日玩指定游戏可获抽卡机会，一天限2次</span>
                <a data-stat="去游戏" :href="youxilink">去游戏</a>
            </div>
        </div>
</template>

<script>
export default {
  props:['ifylxd'],
  data () {
      return {
        shareorder:'', 
         youxilinks:{
                    ule:'//h5.tom.cn/ule/game/oauth/268?channel=ule&mobile=',
                    ylxd:'//h5.tom.cn/ule/game/oauth/269?channel=ylxd&mobile='
        },
        youxilink:'//h5.tom.cn/ule/game/oauth/268?channel=ule&mobile=',
        ruleCode:['CX_QZ_TJ_157795445389051','CX_QZ_TJ_157795454855624','CX_QZ_TJ_157778960293005'],
        ulellan:'0',
        ulefenx:'0',
        ulechengd:'0',
      }
    },
    created(){
      var m=this;
      if(m.ifylxd){
          m.youxilink=m.youxilinks.ylxd;
          //  查询参加人数
       this.HTTP.qryinfobyOwner().then((res) => {
            m.shareorder = res.body.data;
        }, (err) => {
            console.log(err);
        });
      }else{
        this.HTTP.datetime().then((res) => {
                let times=this.BASE.formaDate(res.time,'yyyy-MM-dd');
                m.ulemun(times)
        },(ree) =>{

        })
      } 
    }, 
     methods:{
         ulemun(tim){
            let m=this;
            let ruleCodes=m.ruleCode.join(",")
            this.HTTP.cationByRulehttp(ruleCodes,tim).then((res) => {
            let arr=res.body.content;
            m.ulellan=arr[1].times;
            m.ulefenx=arr[0].times;
            m.ulechengd=arr[2].times;
            }, (err) => {
            console.log(err);
            });
         }
    }, 
}
</script>

<style scoped>
.car-num{
    width: 95%;
    margin: 0 auto;
    padding-bottom: .4rem;
}
.car-con .title{
    width: 100%;
    text-align: center;
    margin-bottom: .35rem;
}
.car-con .title img{
    height: .88rem;
    width:auto;
    display: inline-block;
}
.car-num .car-num-top{
    width: 92%;
    margin: 0 auto;
    height: 1.32rem;
    color: #FFEDB0;
    font-size: .32rem;
    position: relative;
    background: url(//www.ule.com/app/yxd/event/2019/0730/nianhj/images/jika/bg2.png) no-repeat center;
    background-size: 100% 100%;
    margin-bottom: .04rem;
    padding-left: .36rem;
    line-height: .42rem;
    padding-top: .26rem;
    box-sizing: border-box;
}
.car-num .car-num-top i{
    position: absolute;
    width: .46rem;
    height: 100%;
    background: url(//www.ule.com/app/yxd/event/2019/0730/douele/image/ion2.png) no-repeat center;
    background-size: .42rem .4rem;
    left: .36rem;
    top: 0;
    display: none;
}
.car-num .car-num-top.car-num-bot{
    margin-top: 0;
}
.car-num .car-num-top.car-num-bot i{
    background: url(//www.ule.com/app/yxd/event/2019/0730/douele/image/i3.png) no-repeat center;
    background-size: .45rem .45rem;
}
.car-num .car-num-top.car-num-bot.youxi i{
    background: url(//www.ule.com/app/yxd/event/2019/0730/douele/image/ion8.png) no-repeat center;
    background-size: .46rem .43rem;
}
.car-num .car-num-top.car-num-kan i{
    background: url(//www.ule.com/app/yxd/event/2019/0730/twelve/images/jika/i2.png) no-repeat center;
    background-size: .44rem .32rem;
}
.car-num .car-num-top .sp1{
    color: #FFF2C7;
    font-size: .22rem;
}
.car-num .car-num-top .sp2{
    color: #FFE386;
    font-size: .30rem;
}
.car-num .car-num-top .sp3{
    color: #FFE386;
    font-size: .36rem;
}
.car-num-top a{
    display: block;
    width: 1.56rem;
    height: .48rem;
    position: absolute;
    top: .42rem;
    right: .3rem;
    background: url(//www.ule.com/app/yxd/event/2019/0730/nianhj/images/jika/an4.png) no-repeat center;
    background-size:100% 100%;
    font-size: .24rem;
    text-align: center;
    color: #A45E16;
    line-height: .48rem;
}
.car-num-top a.wanc{
    background: url(//www.ule.com/app/yxd/event/2019/0730/nianhj/images/jika/an7.png) no-repeat center;
    background-size:100% 100%;
    color: #FFD28A;
}
</style>



// WEBPACK FOOTER //
// src/components/commont/speed.vue